import {
  RETRIEVE_REPORTING_URI_REQUEST,
  RETRIEVE_REPORTING_URI_SUCCESS,
  RETRIEVE_REPORTING_URI_FAILURE,
  LOAD_ELEMENTS_SCRIPT_REQUEST,
  LOAD_ELEMENTS_SCRIPT_SUCCESS,
  LOAD_ELEMENTS_SCRIPT_FAILURE,
  STORE_STYTCH_ELEMENTS,
} from './constants'

export interface ElementsProps {
  isLoading: boolean,
  hasFinished: boolean,
  error: Error | null,
  errorInstructions?: string,
}

export interface ReportingUriProps {
  isLoading: boolean,
  uri: string | null,
  error: Error | null,
}

export interface StytchWrapperReducerState {
  elements: ElementsProps,
  reportingUri: ReportingUriProps,
}

export interface StytchWrapperActions {
  type: string,
  error: Error | $TSFIXME,
  uri: string | null,
  stytchElements: $TSFIXME,
}

const DEFAULT_STATE: StytchWrapperReducerState = {
  elements: {
    isLoading: false,
    hasFinished: false,
    error: null,
  },
  reportingUri: {
    isLoading: false,
    uri: null,
    error: null,
  },
}

export function stytchWrapper(
  state = DEFAULT_STATE,
  {
    type,
    uri = null,
    error = null,
    stytchElements = null,
  }: StytchWrapperActions,
) {
  switch (type) {
    case LOAD_ELEMENTS_SCRIPT_REQUEST:
      return {
        ...state,
        elements: { isLoading: true, hasFinished: false, error },
      }
    case LOAD_ELEMENTS_SCRIPT_SUCCESS:
      return {
        ...state,
        elements: { isLoading: false, hasFinished: true, error },
      }
    case LOAD_ELEMENTS_SCRIPT_FAILURE:
      return {
        ...state,
        elements: {
          isLoading: false,
          hasFinished: true,
          error: 'Unable to load ' + error.target.src,
          errorInstructions: 'clearCookiesInstruction',
        },
      }
    case RETRIEVE_REPORTING_URI_REQUEST:
      return { ...state, reportingUri: { isLoading: true, uri, error } }
    case RETRIEVE_REPORTING_URI_SUCCESS:
    case RETRIEVE_REPORTING_URI_FAILURE:
      return { ...state, reportingUri: { isLoading: false, uri, error } }
    case STORE_STYTCH_ELEMENTS:
      return { ...state, stytchElements }
    default:
      return state
  }
}
